module.exports = __webpack_public_path__ + "static/img/clinic.131ab458.png";